import React from 'react'
import {
    CalculateOutlined, DescriptionOutlined,
    FileCopyOutlined, FolderCopyOutlined,
    GavelOutlined, InsertDriveFileOutlined, 
    TextSnippetOutlined
} from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const data = [
    {
        id: 1,
        name: 'online_appeals',
        icon: <InsertDriveFileOutlined />,
        link: '/electron-filing'
    },
    {
        id: 2,
        name: 'request_copies',
        icon: <FileCopyOutlined />,
        link: '/act-request'
    },
    {
        id: 3,
        name: 'collection_decisions',
        icon: <TextSnippetOutlined />,
        link: '/collection-decisions'
    },
    {
        id: 4,
        name: 'state_duty',
        icon: <DescriptionOutlined />,
        link: '/state-duty'
    },
    {
        id: 5,
        name: 'calculator',
        icon: <CalculateOutlined />,
        link: '/calculator'
    },
    {
        id: 6,
        name: 'document_sample',
        icon: <FolderCopyOutlined />,
        link: '/document-sample-list'
    },
    {
        id: 8,
        name: 'sale',
        icon: <GavelOutlined />,
        link: '/sale'
    },
]

const UsefulCount = () => {
    const {t} = useTranslation()
    return (
        <div className="bg-white rounded-md dark:bg-dark-box 
                        dark:text-dark-text py-3 text-sm 
                        h-[450px] px-4 ">
            <ul className="space-y-4  max-h-full overflow-y-scroll">
                {data?.map((d) => (
                    <li key={d.id} >
                        <Link to={d.link} className='flex items-center py-2 gap-2'>
                            <span className='bg-white text-primary p-1 rounded-md 
                                        dark:bg-dark-box dark:text-dark-text'>
                                {d.icon}
                            </span>
                            {t(d.name)}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default UsefulCount
